import PropTypes from 'prop-types';
import cx from 'classnames';
import './AuthCard.css';

/**
 * AuthCard — the white form card on the right side of the public pages.
 *
 * Lays out: optional stepper slot → title → subtitle → form children →
 * optional footer slot. The card itself is a glass-edged surface
 * (theme-aware shadow + border).
 *
 * Props:
 *   - title:    visible heading
 *   - subtitle: small helper line under the title
 *   - stepper:  ReactNode rendered above the title (e.g. step indicators)
 *   - footer:   ReactNode rendered below the form children, separated
 *               by a thin divider (used for the "secure HIPAA" footnote
 *               on the login screen)
 *   - children: form contents
 */
const AuthCard = ({ title, subtitle, stepper, footer, children, className, ...rest }) => (
  <section className={cx('qhs-auth-card', className)} {...rest}>
    {stepper && <div className="qhs-auth-card__stepper">{stepper}</div>}
    {title && <h2 className="qhs-auth-card__title">{title}</h2>}
    {subtitle && <p className="qhs-auth-card__subtitle">{subtitle}</p>}
    <div className="qhs-auth-card__body">{children}</div>
    {footer && <div className="qhs-auth-card__footer">{footer}</div>}
  </section>
);

AuthCard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  stepper: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default AuthCard;
